import "./flash_module.scss"

